import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { CircularProgress } from '@mui/material';

import api from 'api';
import { useMountEffect, useRequest } from 'shared/hooks';

import DialogWrapper from 'shared/components/layout/DialogWrapper';

import ClinicalDecisionSupportForm from './ClinicalDecisionSupportForm';

const ClinicalDecisionSupportDetails = ({ onSubmit, onCancel }) => {
  const { doRequest: getResource, data } = useRequest(api.getUserSupportResource);

  const { resourceId } = useParams();

  useMountEffect(() => {
    getResource(resourceId);
  }, [getResource, resourceId]);

  return (
    <DialogWrapper title="Resource Details">
      {data ? (
        <ClinicalDecisionSupportForm
          onCancel={onCancel}
          onSubmit={(values) => onSubmit(resourceId, values)}
          defaultValues={data}
          isEditing
        />
      ) : (
        <CircularProgress />
      )}
    </DialogWrapper>
  );
};

ClinicalDecisionSupportDetails.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ClinicalDecisionSupportDetails;
